import {createRouter, createWebHistory} from "vue-router";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import('@/views/Dashboard.vue')
        },
        {
            path: "/dashboard-editor/:pageId",
            name: "chart-dashboard-editor",
            component: () => import("@/views/chart_builder/ChartDashboardEditor.vue"),
        },
        {
            path: "/users",
            name: "users",
            component: () => import('@/views/users/Users.vue')
        },
        {
            path: "/news",
            name: "news",
            component: () => import("@/views/News.vue"),
        },
        {
            path: "/self-service-news",
            name: "self-service-news",
            component: () => import("@/views/SelfServiceNews.vue"),
        },
        {
            path: "/claims",
            name: "claims",
            component: () => import('@/views/empathic_tickets/EmpathicTickets.vue')
        },
        {
            path: "/claim-information/:ticket_id",
            name: "claim-information",
            component: () => import('@/views/empathic_tickets/TicketInformationNew.vue')
        },
        {
            path: "/company-profile",
            name: "company-profile",
            component: () => import('@/views/users/CompanyProfile.vue')
        },
        {
            path: "/documentation",
            name: "documentation",
            component: () => import('@/views/client_documentation/ClientDocumentation.vue')
        },
        {
            path: "/login",
            name: "login",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/auth/Login.vue')
        },
        {
          path: "/docs",
          name: "docs",
          component: () => import("@/views/ApiDocs.vue"),
        },
        {
            path: "/login-error-block",
            name: "login-error-block",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/LoginErrorBlock.vue"),
        },
        {
            path: "/login-issue",
            name: "login-issue",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/AuthenticationIssue.vue"),
        },
        {
            path: "/voucher-issue",
            name: "voucher-issue",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/VoucherIssue.vue"),
        },
        {
            path: "/session-expired",
            name: "session-expired",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/SessionExpiredIssue.vue"),
        },
        {
            path: "/auth/callback",
            name: "callback",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/auth/ClientCallbackView.vue')
        },
        {
            path: "/impersonate/callback",
            name: "impersonate-callback",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/auth/ImpersonateCallbackView.vue')
        },
        {
            path: "/impersonate/:code/:token",
            name: "impersonate",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/auth/ImpersonateView.vue')
        },
        {
            path: "/reset-password/:hash_reset",
            name: "reset-password",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/users/ResetUserPassword.vue')
        },
        {
            path: "/reset-password",
            name: "reset-password-initial",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/users/ForgotUserPassword.vue')
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/users/ForgotUserPassword.vue')
        },
        {
            path: "/confirm-email/:hash",
            name: "confirm-email",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/users/ConfirmNewEmail.vue')
        },
        {
            path: "/unsubscribe",
            name: "unsubscribe",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import('@/views/notifications/Unsubscribe.vue')
        },
        {
            path: "/manage-user/:id",
            name: "manage-user",
            component: () => import('@/views/users/ManageUser.vue')
        },
        {
            path: "/my-profile/:id",
            name: "my-profile",
            component: () => import("@/views/users/MyProfile.vue"),
        },
        {
            path: "/roles-and-permissions",
            name: "roles-permissions",
            component: () => import('@/views/RolesPermissions.vue')
        },
        {
            path: "/ocean/:status_selected?",
            name: "ocean",
            component: () => import('@/views/shipments/Ocean.vue')
        },
        {
            path: "/air/:status_selected?",
            name: "air",
            component: () => import('@/views/shipments/Air.vue')
        },
        {
            path: "/domestic-shipments",
            name: "domestic-shipments",
            component: () => import('@/views/shipments/Road/DomesticRoad.vue')
        },
        {
            path: "/international-shipments",
            name: "international-shipments",
            component: () => import('@/views/shipments/Road/InternationalRoad.vue')
        },
        {
            path: "/outbounds/:status_selected?",
            name: "outbounds",
            component: () => import('@/views/shipments/Outbounds.vue')
        },
        {
            path: "/strongo-shipments",
            name: "strongo-shipments",
            component: () => import('@/views/shipments/Strongo/Strongo.vue')
        },
        {
            path: "/strongo-shipment-overview/:shipment_id",
            name: "strongo-shipment-overview",
            component: () => import("@/views/shipments/Strongo/ShipmentOverviewStrongo.vue"),
        },
        {
            path: "/inbounds/:status_selected?",
            name: "inbounds",
            component: () => import('@/views/shipments/Inbounds.vue')
        },
        {
            path: "/activity-log",
            name: "activity-log",
            component: () => import('@/views/ActivityLog.vue')
        },
        {
            path: "/vbs-inbounds",
            name: "vbs-inbounds",
            component: () => import('@/views/shipments/VbsReportInbounds.vue')
        },
        {
            path: "/vbs-outbounds",
            name: "vbs-outbounds",
            component: () => import('@/views/shipments/VbsReportOutbounds.vue')
        },
        {
            path: "/vendors",
            name: "vendors",
            component: () => import('@/views/erp/Vendors.vue')
        },
        {
            path: "/vendor-invoice-details/:entry_no",
            name: "vendor-invoice-details",
            component: () => import("@/views/erp/VendorInvoiceDetails.vue"),
        },
        {
            path: "/customers",
            name: "customers",
            component: () => import('@/views/erp/Customers.vue')
        },
        {
            path: "/customer-invoice-details/:entry_no",
            name: "customer-invoice-details",
            component: () => import("@/views/erp/CustomerInvoiceDetails.vue"),
        },
        {
            path: "/order-entry-international-road-transport",
            name: "order-entry-international-road-transport",
            component: () =>
                import("@/views/order_entry/InternationalRoadTransportOrder.vue"),
        },
        {
            path: "/order-entry-international-road-transport/book-again/:order_id",
            name: "order-entry-international-road-transport-book-again",
            component: () =>
                import("@/views/order_entry/InternationalRoadTransportOrder.vue"),
        },
        {
            path: "/order-entry-domestic-road-transport",
            name: "order-entry-domestic-road-transport",
            component: () =>
                import("@/views/order_entry/DomesticRoadTransportOrder.vue"),
        },
        {
            path: "/order-entry-domestic-road-transport/book-again/:order_id",
            name: "order-entry-domestic-road-transport-book-again",
            component: () =>
                import("@/views/order_entry/DomesticRoadTransportOrder.vue"),
        },
        {
            path: "/order-entry-strongo-transport",
            name: "order-entry-strongo-transport",
            component: () =>
                import("@/views/order_entry/StrongoTransportOrder.vue"),
        },
        {
            path: "/order-entry-strongo-transport/book-again/:order_id",
            name: "order-entry-strongo-transport-book-again",
            component: () =>
                import("@/views/order_entry/StrongoTransportOrder.vue"),
        },
        {
            path: "/order-summary",
            name: "order-summary",
            component: () => import("@/views/order_entry/OrderSummary.vue"),
        },
        {
            path: "/shipment-overview/:transport_type/:shipment_id",
            name: "shipment-overview",
            component: () => import("@/views/shipments/Road/ShipmentOverview.vue"),
        },
        {
            path: "/tracking-shipment/:transport_type",
            name: "tracking-shipment",
            meta: {
                layout: "LayoutTracking"
            },
            component: () => import("@/views/shipments/Road/ShipmentOverview.vue"),
        },
        {
            path: "/maintenance",
            name: "maintenance",
            meta: {
                layout: "LayoutTracking"
            },
            component: () => import("@/components/layout/UnderMaintenance.vue"),
        },
        {
            path: "/download-file/:file_type/:resource_id",
            name: "download-pod",
            component: () => import('@/views/DownloadFile.vue')
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (from && Object.keys(to.query).length) {
            if (to.fullPath.split('?')[0] == from.fullPath.split('?')[0]) return;
        }
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        } else if (savedPosition) {
            return savedPosition
        } else {
            return {top: 0}
        }
    },
});

export default router;
